import { render, staticRenderFns } from "./ModuleInfoView.vue?vue&type=template&id=d481bd3a&v-if=applicationModule&"
import script from "./ModuleInfoView.vue?vue&type=script&lang=js&"
export * from "./ModuleInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports